<!-- /* * Confidential and Proprietary. * Do not distribute without 1-800-Flowers.com, Inc. consent. *
Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved. */ -->

<div class="order-card">
	<img
		src={currentSrc}
		alt={order.product_name}
		class="product-image"
		on:error={handleImageError}
		loading="lazy"
	/>
	<div class="order-info">
		{#if order?.status_description?.toLowerCase()?.includes('delayed')}
			<p class="order-title">Apologies, your order is delayed</p>
			<p class="order-subtitle">Originally scheduled for {order?.delivery_date}</p>
		{:else if order?.status?.toLowerCase() === 'cancelled'}
			<p class="order-title">This order has been cancelled</p>
			<p class="order-subtitle">Originally scheduled for {order?.delivery_date}</p>
		{:else if order?.status?.toLowerCase() === 'delivered'}
			<p class="order-title">{order?.product_name}</p>
			<p class="order-subtitle">Delivered {order?.delivery_date}</p>
		{:else}
			<p class="order-title">Scheduled for delivery {order?.delivery_date}</p>
			<p class="order-subtitle">Delivery zip code {order?.order_zip}</p>
		{/if}
	</div>
</div>

<script lang="ts">
	export let order = {} as Record<string, string>;

	let fallbackSrc =
		'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltc881f4b32ef5f484/60dcd2de4b10c259bbae6426/Image_Not_Available.png';
    let currentSrc = order?.image || fallbackSrc;


	function handleImageError() {
		if (currentSrc !== fallbackSrc) {
			currentSrc = fallbackSrc;
		}
	}
</script>

<style>
	.order-card {
		display: flex;
		align-items: flex-start;
		border-radius: 10px;
		overflow: hidden;
		border: 1px solid #e0e0e0;
		background: white;
		margin: 7px 0px;
		max-width: 240px;
		padding: 6px 8px; 
	}

	.product-image {
		width: 80px;
		height: 80px;
		object-fit: cover;
		flex-shrink: 0;
		border-radius: 6px;
	}

	.order-info {
		width: 161;
		height: 61;	
		opacity: 1;
		gap: 4px;
		padding-left: 8px; 
		margin-top: 4px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.order-title {
		font-family: area-variable, sans-serif;
		font-size: 13px; 
		font-weight: 700;
		font-style: bold;
		margin: 0 0 2px 0;
		color: #333;
		line-height: 20px;
		letter-spacing: 1%;
	}

	.order-subtitle {
		font-family: area-variable, sans-serif;
		font-size: 12px;
		font-weight: 400;
		font-style: normal;
		color: #666;
		margin: 0;
		line-height: 17px;
		letter-spacing: 1%;
	}
</style>
